// @ts-nocheck

import {
  CardPaymentActionTypes,
  CardPaymentEventTypes,
  CardPaymentGuardTypes,
  CardPaymentServiceTypes,
  type ChildMachineConfig,
  ParentState,
  PaymentInformationChildState,
  PaymentInformationState,
} from "@hopper-b2b/checkout";
import { GuestCardPaymentActionTypes } from "./actions";
// Guest Card Payment machine handles guest users' payment r5cards
// - does not load saved payment methods from another checkout in the same session
// - every saved payment method is saved within the context and does not show in subsequent re-entries to checkout

export const GuestCardPaymentState = "guestCardPayment";
export const PaymentRouteState = "paymentRoute";

export const getMachineState = (config: ChildMachineConfig) => ({
  id: ParentState.cardPayment,
  initial: PaymentInformationState.idle,
  always: {
    actions: CardPaymentActionTypes.setPaymentVisited,
    cond: CardPaymentGuardTypes.notVisitedPayment,
  },
  states: {
    [PaymentInformationState.idle]: {
      on: {
        [CardPaymentEventTypes.SET_SELECTED_PAYMENT_METHOD_ID]: {
          actions: CardPaymentActionTypes.setSelectedPaymentMethodId,
        },
      },
    },
    [PaymentInformationState.add]: {
      initial: PaymentInformationChildState.idle,
      states: {
        [PaymentInformationChildState.idle]: {},
        [PaymentInformationChildState.verify]: {
          invoke: {
            src: CardPaymentServiceTypes.verifyPayment,
            onDone: {
              actions: GuestCardPaymentActionTypes.guestSetPaymentMethodId,
              target: config.nextState,
            },
            onError: {
              actions: CardPaymentActionTypes.setPaymentError,
              target: `#${config.parentMachineId}.${GuestCardPaymentState}.${PaymentInformationState.error}`,
            },
          },
        },
      },
    },
    [PaymentInformationState.delete]: {
      invoke: {
        src: CardPaymentServiceTypes.deletePaymentMethod,
        onDone: {
          actions: GuestCardPaymentActionTypes.guestDeletePaymentMethod,
          target: `#${config.parentMachineId}.${GuestCardPaymentState}.${PaymentInformationState.idle}`,
        },
        onError: {
          actions: CardPaymentActionTypes.setPaymentError,
          target: `#${config.parentMachineId}.${GuestCardPaymentState}.${PaymentInformationState.error}`,
        },
      },
    },
    [PaymentInformationState.error]: {
      on: {
        [CardPaymentEventTypes.CLEAR_PAYMENT_ERROR]: {
          target: `#${config.parentMachineId}.${GuestCardPaymentState}.${PaymentInformationState.idle}`,
        },
      },
    },
  },
  on: {
    [CardPaymentEventTypes.PREVIOUS]: {
      target: config.previousState,
    },
    [CardPaymentEventTypes.NEXT]: {
      target: config.nextState,
    },
    [CardPaymentEventTypes.OPEN_PAYMENT_FORM]: `#${config.parentMachineId}.${GuestCardPaymentState}.${PaymentInformationState.add}`,
    [CardPaymentEventTypes.CLOSE_PAYMENT_FORM]: `#${config.parentMachineId}.${GuestCardPaymentState}.${PaymentInformationState.idle}`,
    [CardPaymentEventTypes.VERIFY_PAYMENT_METHOD]: {
      actions: CardPaymentActionTypes.setSpreedlyToken,
      target: `#${config.parentMachineId}.${GuestCardPaymentState}.${PaymentInformationState.add}.${PaymentInformationChildState.verify}`,
    },
    [CardPaymentEventTypes.DELETE_PAYMENT_METHOD]: {
      target: `#${config.parentMachineId}.${GuestCardPaymentState}.${PaymentInformationState.delete}`,
    },
  },
});
